/* 名片文本 → 经纪人字段（纯规则、即时；识别不全时用 /tm/parse-card AI 补全） */
const PHONE = /(?:\+?1[\s.-]*)?\(?(\d{3})\)?[\s.-]*(\d{3})[\s.-]*(\d{4})\b/g;
const EMAIL = /[\w.+-]+@[\w-]+(?:\.[\w-]+)+/i;
const URL = /(?:https?:\/\/|www\.)\S+|\b[\w-]+\.(?:com|net|org|realtor|homes|io)\b/i;
const DRE = /(?:DRE|BRE|CalDRE|CalBRE|Lic(?:ense|\.)?|License|执照|牌照)\s*(?:#|No\.?|:|：)?\s*#?\s*(\d{8})\b/i;
const CSZ = /([A-Za-z][A-Za-z .'-]{1,40}?),?\s+(?:CA|Calif(?:ornia)?)\.?,?\s*(9\d{4})(?:-\d{4})?/;
const STREET = /^\s*\d{1,6}\s+[A-Za-z0-9 .'#-]*?\b(?:St|Street|Ave|Avenue|Blvd|Boulevard|Dr|Drive|Rd|Road|Ln|Lane|Ct|Court|Pl|Place|Way|Hwy|Highway|Pkwy|Parkway|Cir|Circle|Ter|Trl)\b\.?(?:[ ,]*(?:#|Ste\.?|Suite|Unit)\s*\w+)?/i;
const BROKER = /realty|real estate|properties|property|brokerage|homes\b|compass|keller williams|\bkw\b|re\/max|remax|coldwell|\bexp\b|century 21|sotheby|berkshire|redfin|realtors\b|group\b|\binc\b|llc|地产|房产|不动产|置业/i;
const TITLE = /\b(realtor|broker|agent|associate|president|manager|director|founder|owner|ceo|team lead|specialist|consultant|advisor)\b|经纪|经理|总监|顾问|总裁|创始人/i;
const AREAS = /^(?:serving|service areas?|areas?|coverage|服务区域|服务地区)\s*[:：]?\s*(.+)$/i;
const BIZ = /residential|commercial|luxury|investment|leasing|rental|property management|new construction|住宅|商业|豪宅|投资|租赁/i;
const OFFICE_LBL = /\b(office|ofc|o|tel|work|main)\b\s*[:：.]?\s*$|公司|办公|座机/i;
const CELL_LBL = /\b(cell|mobile|m|c|direct|d)\b\s*[:：.]?\s*$|手机|移动/i;
const FAX_LBL = /\bfax\b\s*[:：.]?\s*$|传真/i;
const CN_NAME = /^[\u4e00-\u9fa5]{2,4}$/;

const fmt = (d) => `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
const clean = (s) => s.replace(/[®™]/g, "").replace(DRE, "").replace(/\s{2,}/g, " ").trim();

export function parseCard(text) {
  const out = {};
  const lines = String(text || "").split(/\r?\n|[|•●▪]|(?<=\S)\s{3,}(?=\S)/).map((l) => l.trim()).filter(Boolean);
  const used = new Set();
  const phones = [];
  lines.forEach((l, i) => {
    let m; PHONE.lastIndex = 0;
    while ((m = PHONE.exec(l))) {
      const lbl = l.slice(Math.max(0, m.index - 14), m.index);
      const kind = FAX_LBL.test(lbl) ? "fax" : CELL_LBL.test(lbl) ? "cell" : OFFICE_LBL.test(lbl) ? "office" : "none";
      phones.push({ d: m[1] + m[2] + m[3], kind });
      used.add(i);
    }
    if (EMAIL.test(l)) { out.email = out.email || l.match(EMAIL)[0].toLowerCase(); used.add(i); }
    if (URL.test(l) && !EMAIL.test(l)) used.add(i);
    const dre = l.match(DRE);
    if (dre) { out.dreLicense = out.dreLicense || dre[1]; if (clean(l).length < 3) used.add(i); }
    const csz = l.match(CSZ);
    if (csz) { out.city = out.city || csz[1].trim(); out.zip = out.zip || csz[2]; used.add(i); }
  });
  const office = phones.find((p) => p.kind === "office");
  const personal = phones.filter((p) => p.kind !== "fax" && p !== office && !phones.slice(0, phones.indexOf(p)).some((q) => q.d === p.d));
  const cellFirst = [...personal.filter((p) => p.kind === "cell"), ...personal.filter((p) => p.kind !== "cell")];
  if (cellFirst[0]) out.phone = fmt(cellFirst[0].d);
  if (cellFirst[1]) out.altPhone = fmt(cellFirst[1].d);
  if (office) out.officePhone = fmt(office.d);
  lines.forEach((l, i) => {
    const st = l.match(STREET);
    if (st && !out.address) {
      out.address = st[0].replace(/,\s*$/, "").trim(); used.add(i);
      const nx = lines[i + 1]?.match(CSZ);
      if (nx) { out.city = out.city || nx[1].trim(); out.zip = out.zip || nx[2]; used.add(i + 1); }
    }
    const ar = l.match(AREAS);
    if (ar && !out.serviceAreas) { out.serviceAreas = ar[1].trim(); used.add(i); }
  });
  lines.forEach((l, i) => {
    if (used.has(i)) return;
    const c = clean(l);
    if (!out.brokerage && BROKER.test(c) && !TITLE.test(c.replace(BROKER, ""))) { out.brokerage = c; used.add(i); }
  });
  lines.forEach((l, i) => {
    if (used.has(i) || out.fullName) return;
    const c = clean(l).split(/\s*(?:,|-|–|—|\/)\s*/)[0].trim();
    if (!c || /\d/.test(c) || c.length > 40 || BROKER.test(c) || TITLE.test(c) || BIZ.test(c) || AREAS.test(c)) return;
    const words = c.split(/\s+/);
    if (CN_NAME.test(c) || (words.length >= 1 && words.length <= 4 && /^[A-Za-z][A-Za-z.' -]+$/.test(c))) { out.fullName = c; used.add(i); }
  });
  lines.forEach((l, i) => {
    if (used.has(i) || out.businessTypes) return;
    const c = clean(l);
    if (BIZ.test(c) && c.length < 80 && !/\d/.test(c)) { out.businessTypes = c.replace(/\s*[|•·]\s*/g, ", "); used.add(i); }
  });
  return out;
}
